export default "__VITE_ASSET__T05A7qKG__"